<template>
  <div>
    <div class="shadow-card">
      <!-- <p>{{ quiz.quiz_title }}</p> -->
      <div
        class="question"
        :style="optionLocked ? 'pointer-events:none' : ''"
        v-if="!finished"
      >
        <p>Question {{ currentQuestion }} of {{ totalQuestions }}</p>
        <p>{{ question.question_text }}</p>
        <a-radio-group @change="onChange">
          <div
            v-for="option in question.options"
            :key="option.id"
            class="question-option"
          >
            <a-radio :value="option">{{ option.option }}</a-radio>
          </div>
        </a-radio-group>
        <p>
          <button
            class="dovemed-button primary-background primary-button font-white"
            :style="{
              background: getPrimaryColor(),
              border: '1px solid' + getPrimaryColor()
            }"
            @click="submitResponse()"
            v-if="!optionLocked"
          >
            Submit
          </button>
        </p>
      </div>
      <div v-if="finished">
        <p>
          You answered {{ correctAnswers }} question correctly out of
          {{ totalQuestions }}, giving you a
          {{ Math.abs(correctAnswers / totalQuestions) * 100 }}% percent.
        </p>
        <div class="row" v-for="question in quiz.questions" :key="question.id">
          <div class="col-4">
            {{ question.question_text }}
          </div>
          <div class="col-4">
            <p v-if="getQuestionResponse(question).qR.__o">
              <i class="fa fa-check" aria-hidden="true"></i>
            </p>
            <p v-else><i class="fa fa-times" aria-hidden="true"></i></p>
          </div>
          <div class="col-4">
            {{ getQuestionResponse(question).cO.option }}
          </div>
        </div>
      </div>
      <div v-if="optionLocked">
        <p v-if="selectedOption.is_correct" class="answer-correct">Correct</p>
        <p v-if="!selectedOption.is_correct" class="answer-incorrect">
          Incorect
        </p>
      </div>
      <button
        v-if="currentQuestion !== totalQuestions && optionLocked"
        class="dovemed-button primary-background font-white primary-button"
        :style="{ background: getPrimaryColor() }"
        @click="igniteNextQuestion()"
      >
        Next
      </button>
      <button
        v-if="currentQuestion === totalQuestions && optionLocked"
        class="dovemed-button primary-background font-white primary-button"
        :style="{ background: getPrimaryColor() }"
        @click="finishQuiz()"
      >
        Finish
      </button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "Quiz",
  props: {
    quizData: Object
  },
  data() {
    return {
      quiz: null,
      currentQuestion: null,
      totalQuestions: null,
      question: null,
      selectedOption: null,
      correctAnswers: 0,
      optionLocked: false,
      finished: false,
      qResponses: []
    };
  },

  created() {
    this.quiz = this.quizData;
    this.igniteQuestions();
    localStorage.setItem("__qz", JSON.stringify(this.quiz));
    localStorage.setItem("__qr", this.qResponses);
  },

  methods: {
    getQuestionResponse(question) {
      const qR = JSON.parse(localStorage.getItem("__qr"));
      const qRFiltered = qR.filter(q => q.__q === question.id);

      const cOptionFiltered = question.options.filter(
        o => o.is_correct === true
      );

      return {
        qR: qRFiltered[0],
        cO: cOptionFiltered[0]
      };
    },

    onChange(e) {
      this.selectedOption = e.target.value;
    },

    igniteQuestions() {
      this.totalQuestions = this.quiz.questions.length;
      if (this.totalQuestions) {
        this.currentQuestion = 1;
        this.question = this.quiz.questions[this.currentQuestion - 1];
      }
    },

    igniteNextQuestion() {
      this.currentQuestion += 1;
      if (this.currentQuestion <= this.totalQuestions) {
        this.question = this.quiz.questions[this.currentQuestion - 1];
      }
      this.selectedOption = null;
      this.optionLocked = false;
    },

    submitResponse() {
      const user = JSON.parse(localStorage.getItem("user"));
      const currentCircle = JSON.parse(localStorage.getItem("currentCircle"));
      const payload = {
        user_circle: currentCircle.id,
        user: user.user.id,
        user_quiz: this.quiz.id,
        user_quiz_question: this.question.id,
        user_answer: this.selectedOption.id
      };

      const headers = {
        Authorization: `Bearer ${user.user.token}`
      };
      this.$http
        .post(`${process.env.BASE_API_URL}/quiz_response/`, payload, {
          headers
        })
        .then(res => {
          this.selectedOption.is_correct ? (this.correctAnswers += 1) : null;
          this.optionLocked = true;
          const stepReponsePayload = {
            __q: this.selectedOption.question,
            __o: this.selectedOption.is_correct
          };
          this.qResponses.push(stepReponsePayload);

          localStorage.setItem("__qr", JSON.stringify(this.qResponses));
        })
        .catch(err => {});
    },

    finishQuiz() {
      this.finished = true;
      this.optionLocked = false;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/home/quiz/Quiz.vue